import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import {redirect} from '../../../v2/api/redirect';
import Translation from '../../../v2/lang/Translation';
import {getSettings, getSiteDataV2} from '../../../v2/selectors/selectors';
import Spacing from '../../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  title: {
    marginBottom: Spacing.double,
  },
});

export function EGifting(props) {
  const classes = useStyles();
  
  return (
    <div data-test="EGifting">
      <h2 className={classes.title}>
        <Translation>egifting.title</Translation>
      </h2>
      <p>
        <Translation>egifting.content</Translation>
      </p>
      <Button
        id="EGifting__button"
        onClick={() => redirect.doRedirect(`${props.unsecureHomePageUrl + props.eGiftingUrl}.list`)}
        fullWidth
        primary
      >
        <Translation>egifting.button</Translation>
      </Button>
    </div>
  );
}

const mapStateToProps = (state) => {
  const settings = getSettings(state);
  const siteDataV2 = getSiteDataV2(state);
  
  return {
    unsecureHomePageUrl: siteDataV2.unsecureHomePageUrl,
    eGiftingUrl: settings.egifting_url,
  };
};

EGifting.propTypes = {
  unsecureHomePageUrl: PropTypes.string.isRequired,
  eGiftingUrl: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(EGifting);
